import React from 'react';
import { observer, inject } from 'mobx-react';

@inject('layoutStore')
@observer
export default class SystemField extends React.Component{
    constructor(){
        super();
    }
    shouldComponentUpdate(){
        return false;
    }
    render(){
        const { cellObj,layoutStore } = this.props;
        const { etype } = cellObj;
        const fieldid = cellObj.field && cellObj.field.toString();
        const { cellInfo } = layoutStore;
        const { workflowname="",workflowtypename="",workflowdesc="" } = cellInfo.sysFieldInfo || {};
        let text = "";
        if(etype == "28"){
            text = cellObj.evalue;
        }else if(etype == "29"){
            if(fieldid == "1")
                text = workflowname;
            else if(fieldid == "2")
                text = workflowtypename;
            else if(fieldid == "3")
                text = workflowdesc;
        }
        text = text.replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/(\r\n|\r|\n)/g, "</br>");
        text = text.replace(/ /g,"&nbsp;");

        return (
            <span dangerouslySetInnerHTML={{__html: `${text}`}}></span>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/cellType/SystemField.js